import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'Search',
      title: 'Decodificación en Tiempo Real',
      description: 'Consulta instantánea de VIN con resultados precisos en menos de 2 segundos. Acceso a información completa del vehículo.',
      benefits: ['Búsqueda instantánea', 'Datos verificados', 'Historial completo']
    },
    {
      icon: 'Database',
      title: 'Datos Completos de Vehículos',
      description: 'Información detallada incluyendo especificaciones técnicas, equipamiento, valores comerciales y más.',
      benefits: ['Especificaciones técnicas', 'Equipamiento detallado', 'Valores de mercado']
    },
    {
      icon: 'History',
      title: 'Auditorías y Trazabilidad',
      description: 'Registro completo de todas las consultas con filtros avanzados, exportación de datos y análisis detallado.',
      benefits: ['Registro completo', 'Exportación flexible', 'Análisis avanzado']
    },
    {
      icon: 'Users',
      title: 'Gestión de Usuarios',
      description: 'Control total de accesos con roles personalizados, permisos granulares y administración centralizada.',
      benefits: ['Roles personalizados', 'Control de acceso', 'Gestión centralizada']
    },
    {
      icon: 'Shield',
      title: 'Seguridad Avanzada',
      description: 'Autenticación de dos factores, políticas de seguridad configurables y cumplimiento normativo garantizado.',
      benefits: ['2FA integrado', 'Políticas personalizables', 'Cumplimiento normativo']
    },
    {
      icon: 'BarChart3',
      title: 'Reportes y Métricas',
      description: 'Dashboard con métricas en tiempo real, análisis de uso y reportes personalizables para toma de decisiones.',
      benefits: ['Métricas en tiempo real', 'Reportes personalizados', 'Análisis de tendencias']
    }
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Características de la Plataforma
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Todo lo que necesitas para gestionar consultas de VIN de manera profesional y eficiente
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <div 
              key={index}
              className="bg-card border border-border rounded-lg p-6 shadow-elevation hover:shadow-elevation-md transition-all duration-300 hover:-translate-y-1"
            >
              {/* Icon */}
              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg mb-4">
                <Icon name={feature?.icon} size={24} className="text-primary" />
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {feature?.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-muted-foreground mb-4">
                {feature?.description}
              </p>

              {/* Benefits */}
              <ul className="space-y-2">
                {feature?.benefits?.map((benefit, idx) => (
                  <li key={idx} className="flex items-start space-x-2 text-sm">
                    <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                    <span className="text-muted-foreground">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;